var _defs, _tspan, _tspan2, _tspan3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoMediaLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.59,350.26c.15-1,3.65-25.18-3.36-33.51a7.59,7.59,0,0,0-5.82-2.87c-14.16-.33-16.09,11-16.11,11.15l1.67.26c.06-.41,1.74-10,14.39-9.72a5.89,5.89,0,0,1,4.57,2.26c6.53,7.76,3,31.93,3,32.18Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.44,349.16l1.69-.06c0-.22-.56-22.25,10.29-26.8,10.64-4.45,15.43,4.71,15.62,5.1l1.51-.76c-.05-.11-5.67-11-17.78-5.89C418.85,325.74,419.41,348.2,419.44,349.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.39,350.89c0-.35.11-35.19,6.9-45.38,6.52-9.79,17-5.18,17.49-5l.69-1.54c-.12-.05-12.26-5.41-19.59,5.58-7.07,10.61-7.17,44.86-7.17,46.31Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.38,314.72s6.18,2.28,4.34,7.65-21.37,14.23-21.37,14.23-8.19-7.5-.67-19.7S407.21,310.87,407.38,314.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.59,303.67s-4.38-.47-4-3.14,17.05-9.55,26.91,1.57c0,0-6.31,10.84-15.43,11S426.59,303.67,426.59,303.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.1,321.52s-3-2.44.24-3.63,19.3-.86,19.46,15c0,0-18.67,3.11-21-2.94S431.1,321.52,431.1,321.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.06 382.61 433.04 382.61 436.16 350.89 400.94 350.89 404.06 382.61",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.39,
    y: 347.38,
    width: 38.32,
    height: 7,
    transform: "translate(837.1 701.77) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.45,281.75s-3.61-7.86.51-15.62,5.31-9.58,2.69-11.17-3.83,6.21-3.83,6.21a17.47,17.47,0,0,1-.39-11c1.83-5.61,3-14.75.48-15.73s-.48,11.4-2.64,15.62a36.37,36.37,0,0,1-2.12-9.21c-.3-4.5.17-11.7-1.8-13.54s-3.24-.57-1.3,9.37a103.56,103.56,0,0,1,1.92,18s-4.28-13-7.15-13.43-2.86,3.85-.41,7.51,7.2,10.23,8,13.61c0,0-4.7-9.82-8.92-6.81s3.68,8.94,7.2,11.08,6,15.57,6,15.57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.6,285s3.51-7.92-.7-15.61-5.43-9.5-2.82-11.13,3.9,6.15,3.9,6.15a17.55,17.55,0,0,0,.26-11c-1.9-5.58-3.15-14.7-.67-15.72s.61,11.39,2.83,15.58a36.67,36.67,0,0,0,2-9.24c.24-4.51-.31-11.69,1.64-13.57s3.23-.62,1.41,9.36a104,104,0,0,0-1.71,18.05s4.12-13.11,7-13.53,2.91,3.8.5,7.5-7.08,10.34-7.81,13.73c0,0,4.58-9.89,8.84-6.94s-3.57,9-7.07,11.18-5.78,15.66-5.78,15.66Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.79 279.33 121.79 279.33 124.14 300.09 148.45 300.09 150.79 279.33",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.97 299.61 49.97 382.61 55.97 382.61 55.97 311.61 150.97 311.61 150.97 382.61 157.97 382.61 157.97 299.61 49.97 299.61",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.97 299.61 104.97 382.61 110.97 382.61 110.97 311.61 205.97 311.61 205.97 382.61 212.97 382.61 212.97 299.61 104.97 299.61",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.93,349.85l-3-.42c.53-3.74,3.66-10.82,11.66-10.82,9.47,0,14.19,5.47,14.66,10.9l-3,.26c-.35-4.06-4.1-8.16-11.67-8.16C234.24,341.61,233,349.52,232.93,349.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.47,
    y: 347.21,
    width: 58.39,
    height: 34.86,
    rx: 4.83,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.28,382.61C215,382.61,213,354.3,213,354l1.68-3.28c.07,1.05,3.32,28.87,41.63,28.87,15.77,0,29.38,0,30.76-3,1.21-2.65-4.7-9.46-14.18-20.37V352c12.08,13.91,18.92,21.39,16.91,25.8C287.68,382.43,278.56,382.61,256.28,382.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.11,72.74v29.55a2.81,2.81,0,0,0,3,2.77h99.82s11.54-5.38,10.72-12.9c-.66-6-1.33-10.89-1.89-14.61a9.18,9.18,0,0,0-9.14-7.82H55.11A3,3,0,0,0,52.11,72.74Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.11,72.74v29.55a2.81,2.81,0,0,0,3,2.77h8.8s11.55-5.38,10.72-12.9c-.65-6-1.33-10.89-1.88-14.61a9.19,9.19,0,0,0-9.14-7.82h-8.5A3,3,0,0,0,52.11,72.74Z",
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.35,94.53H76.16s-2.88,6.39-7.77,9h85.19S162.6,99.42,163.35,94.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.34 100.55 73.15 100.55 74.41 103.56 157.34 103.56 157.34 100.55",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.35 96.79 76.16 96.79 77.41 99.8 160.35 99.8 160.35 96.79",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.17,
    y: 92.28,
    width: 2.13,
    height: 0.88,
    transform: "translate(160.46 185.44) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.17,
    y: 92.28,
    width: 2.13,
    height: 0.88,
    transform: "translate(166.48 185.44) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-3",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.55,146.78v167.4a7.05,7.05,0,0,1-7.05,7.05h-237a7.06,7.06,0,0,1-7.06-7.05V146.78a7.06,7.06,0,0,1,7.06-7.06h237A7.06,7.06,0,0,1,423.55,146.78Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.55,146.78v167.4a7.05,7.05,0,0,1-7.05,7.05h-237a7.06,7.06,0,0,1-7.06-7.05V146.78a7.06,7.06,0,0,1,7.06-7.06h237A7.06,7.06,0,0,1,423.55,146.78Z",
    style: {
      fill: "#fff",
      opacity: 0.8,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.55,146.78v13H172.46v-13a7.06,7.06,0,0,1,7.06-7.06h237A7.06,7.06,0,0,1,423.55,146.78Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.22,150.46a3.72,3.72,0,1,1-3.71-3.71A3.71,3.71,0,0,1,415.22,150.46Z",
    style: {
      fill: "#00AB65",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.72,150.46a3.72,3.72,0,1,1-3.71-3.71A3.71,3.71,0,0,1,401.72,150.46Z",
    style: {
      fill: "#00AB65",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.22,150.46a3.72,3.72,0,1,1-3.71-3.71A3.71,3.71,0,0,1,388.22,150.46Z",
    style: {
      fill: "#00AB65",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.97,
    y: 168.37,
    width: 241.98,
    height: 13.71,
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.06,
    y: 186.38,
    width: 241.89,
    height: 118.66,
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Images--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 370.23,
    y: 86.78,
    width: 51.36,
    height: 42.44,
    transform: "translate(791.82 216) rotate(180)",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.23,86.78v42.44h51.36V86.78Zm1.67,1.68h48v39.08h-48Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.23,
    y: 86.78,
    width: 51.36,
    height: 42.44,
    transform: "translate(791.82 216) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.92 115.96 405.19 105.26 394.26 115.96 383.32 109.71 371.9 116.73 371.9 127.54 419.92 127.54 419.92 115.96",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.75,
    cy: 98.1,
    r: 3.52,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.64,
    y: 291.67,
    width: 62.12,
    height: 51.33,
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.64,291.67V343h62.12V291.67Zm60.1,49.3H296.66V293.69h58.08Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.67 321.53 308.46 309.61 318.37 320.69 324.74 317.33 330.11 322.93 334.36 320.69 339.79 325.6 354.74 325.6 354.74 340.97 296.67 340.97 296.67 321.53",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.68,301.31a4.25,4.25,0,0,1-4,5.77,4.1,4.1,0,0,1-1.32-.21,4.25,4.25,0,1,0,5.29-5.56Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.36,341h-38.7V321.53l11.8-11.92,9.91,11.08,6.38-3.36,5.36,5.59,4.25-2.23,5.43,4.91s-17.7,3-17.53,8.32S335.36,341,335.36,341Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.42,
    y: 188.09,
    width: 83.03,
    height: 68.61,
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.42,188.09V256.7h83V188.09ZM401.75,254H324.13V190.8h77.62Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.13 225.42 338.47 214.08 356.45 227.87 379.4 209.49 401.75 225.98 401.75 253.99 324.13 253.99 324.13 225.42",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.13,
    y: 236.09,
    width: 77.61,
    height: 17.9,
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.87 236.09 373.36 253.99 387.8 253.99 357.87 236.09",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.33,
    cy: 208.62,
    r: 4.44,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.33,
    y: 171.89,
    width: 53.9,
    height: 44.54,
    transform: "translate(368.57 388.31) rotate(180)",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.33,171.89v44.54h53.91V171.89Zm1.76,1.76h50.39v41H159.09Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.33,
    y: 171.89,
    width: 53.9,
    height: 44.54,
    transform: "translate(368.57 388.31) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.48 196.12 200.17 188.76 188.5 197.71 173.6 185.78 159.09 196.48 159.09 214.67 209.48 214.67 209.48 196.12",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.09,
    y: 203.04,
    width: 50.39,
    height: 11.62,
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.57 203.04 177.52 214.67 168.14 214.67 187.57 203.04",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.34,185.21a2.88,2.88,0,1,0,2.88-2.88A2.88,2.88,0,0,0,186.34,185.21Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.45,
    y: 98.06,
    width: 122.62,
    height: 101.32,
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.45,98.06V199.38H341.07V98.06Zm118.62,97.32H222.45V102.06H337.07Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.45 167.73 257.6 142.19 283.71 167.73 309.82 152.79 337.07 169.58 337.07 195.38 222.45 195.38 222.45 167.73",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.25,125.08a8.4,8.4,0,1,1-8.4-8.4A8.4,8.4,0,0,1,305.25,125.08Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.65,291.64l6-4.66s.32-2.65,1.63-3.44,6.69-2.91,8-2.81,1.69,5.12,1.32,5.94-8.19,3.11-8.19,3.11l-7.23,7.14Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.93,308.2c9-2.24,23.08-4.66,28.58-7.5s14.35-9.52,16.05-9.9c0,0,3.3,2.29,4.36,4.21,0,0-7.82,10.18-19.26,15.6s-26.55,9.68-26.55,9.68Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.92,295s-7.82,10.19-19.26,15.61c-3.88,1.83-8.19,3.55-12.19,5-7.77,2.83-14.36,4.69-14.36,4.69l-1.68-6.38-1.5-5.71c9-2.25,23.08-4.66,28.57-7.5s14.36-9.52,16.06-9.9C164.56,290.8,167.87,293.09,168.92,295Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.56 290.81 167.1 288.81 171.27 292.38 168.92 295.01 164.56 290.81",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.47,315.6c-7.77,2.83-14.36,4.69-14.36,4.69l-1.68-6.38A59.93,59.93,0,0,1,137.47,315.6Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.61,363.31l4.81,14.63c14.83-3.45,53.36-10.7,59.2,5.61,7.25,20.26-45.17,36.42-74.19,37.41s-44.33-15.13-26-57.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.61,363.31l4.81,14.63c14.83-3.45,53.36-10.7,59.2,5.61,7.25,20.26-45.17,36.42-74.19,37.41s-44.33-15.13-26-57.42Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.22,412.19a.18.18,0,0,1-.22,0A.15.15,0,0,1,178,412c.1-.32,1.06-3.11,2-3.4a.6.6,0,0,1,.58.17,1,1,0,0,1,.34.93A2.47,2.47,0,0,1,180,411,9.92,9.92,0,0,1,178.22,412.19Zm.25-.53a4.15,4.15,0,0,0,2.06-2,.62.62,0,0,0-.24-.64.21.21,0,0,0-.23-.07.61.61,0,0,0-.22.13A8,8,0,0,0,178.47,411.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.16,412.23a.18.18,0,0,1-.18-.05c-.09-.08-1.43-1.77-1.21-2.91a1.07,1.07,0,0,1,.47-.7.62.62,0,0,1,.77-.07c.7.49.62,2.75.27,3.61l0,.09A.17.17,0,0,1,178.16,412.23Zm-.76-3.31a.68.68,0,0,0-.23.4,3.9,3.9,0,0,0,.9,2.33c.22-1,.15-2.56-.26-2.84-.05,0-.13-.09-.34.05l-.07.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.21,417a.17.17,0,0,1,.19-.09.15.15,0,0,1,.14.13c.07.33.58,3.23-.13,4a.58.58,0,0,1-.59.13,1,1,0,0,1-.75-.65,2.56,2.56,0,0,1,.16-1.59A10.59,10.59,0,0,1,127.21,417Zm0,.59a4.1,4.1,0,0,0-.84,2.74.62.62,0,0,0,.52.44.21.21,0,0,0,.23-.05.64.64,0,0,0,.14-.22A8.13,8.13,0,0,0,127.25,417.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.2 402.27 134.27 406.52 128.53 408.56 130 414.83 135.56 413.65 149.12 410.76 146.2 402.27",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.57,415.13l-1-7.4a.73.73,0,0,0-.85-.63l-3.65.61s-5,.46-6,1.74c-2.88,3.72-1.08,20.15.84,20.73.71.21,1.45-.76,1.76-1.42,1-2.12,2.68-7.66,3.51-9.41,1-2.05,3.65-3.06,4.85-3.42A.73.73,0,0,0,131.57,415.13Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.24,416.89a.16.16,0,0,1,.18,0c.12,0,2.11.86,2.47,2a1.07,1.07,0,0,1-.07.84.62.62,0,0,1-.64.44c-.85-.1-1.87-2.12-2-3l0-.08A.16.16,0,0,1,127.24,416.89Zm2.27,2.53a.66.66,0,0,0,0-.46c-.23-.7-1.34-1.33-1.91-1.6.27.95,1.1,2.3,1.6,2.35,0,0,.16,0,.27-.21l0-.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.2 402.27 134.27 406.52 135.56 413.65 149.12 410.76 146.2 402.27",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.67 414.72 141.1 414.97 138.81 403.16 134.91 405.31 137.67 414.72",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.67 414.72 141.1 414.97 138.81 403.16 134.91 405.31 137.67 414.72",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.88,368.83l17.87,19.82s19.77-.44,43.77,11.3c0,0,25.76-10.64,28.13-19.48s-54.07-2.59-54.07-2.59Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.23,320.35c3.19,9.58,3.34,31.23,2.21,43.19l36.17-.23c6.22-23.86,4.12-40.6,3.59-46.19-.66-6.8-1.71-7.06-1.71-7.06s-7.38-.72-13.8-.67A105.35,105.35,0,0,0,95.87,311a99.18,99.18,0,0,0-10.8,2.43,2.87,2.87,0,0,0-1.93,3.69C83.52,318.19,83.89,319.29,84.23,320.35Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.61,363.31l-21.81.14-14.36.09a180.13,180.13,0,0,0-.29-33.47,51.43,51.43,0,0,0-1.92-9.72c-.34-1.06-.71-2.16-1.09-3.28a2.87,2.87,0,0,1,1.93-3.69A99.18,99.18,0,0,1,95.87,311a105.35,105.35,0,0,1,14.82-1.56c6.42-.05,13.8.67,13.8.67s1.05.26,1.71,7.06C126.73,322.71,128.83,339.45,122.61,363.31Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.83,328.41c15-4.7,15.27,21.89-.3,25.58S97.58,332.89,111.83,328.41Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.3,329.92c2.71-.06-9.82,21.57-21.29,23.55,0,0,8.12,1.23,17.67-9.63s8.61-14.19,7.88-15S120.3,329.92,120.3,329.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.03 334.79 108.23 335.83 109.76 335.42 109.15 336.89 110.01 338.22 108.43 338.09 107.42 339.32 107.06 337.77 105.58 337.2 106.94 336.38 107.03 334.79",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.44,363.54a180.13,180.13,0,0,0-.29-33.47c4.45,6.32,12.28,19.07,14.65,33.38Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,376.49s9,5.88,10.06,6.34,7.73,2.1,9.65,2-.65-6.1-2.3-6.88-7.55.29-7.55.29l-7-5.26Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.74,382.83v2.94c0,.75-.89,1.06-1.64,1.06H111.4c-.76,0-1.66-.31-1.66-1.06v-2.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.74,382.83v2.94c0,.75-.89,1.06-1.64,1.06H111.4c-.76,0-1.66-.31-1.66-1.06v-2.94Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.74,382.83v2.94c0,.75-.89,1.06-1.64,1.06H131.38c-.75,0-1.64-.31-1.64-1.06v-2.94Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.56,352.33l-7,31.7a2.38,2.38,0,0,1-2.27,1.8H134.13a1.54,1.54,0,0,1-1.44-2l7-31.46a2.19,2.19,0,0,1,2.27-1.55h38.18C181.14,350.83,181.79,351.29,181.56,352.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.56,352.33l-7,31.7a2.38,2.38,0,0,1-2.27,1.8H135.42a1.54,1.54,0,0,1-1.44-2l7-31.46a2.18,2.18,0,0,1,2.27-1.55h36.88C181.14,350.83,181.79,351.29,181.56,352.33Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.74,368.44h0c0,2.71-2.91,4.92-5.05,4.92s-3.39-2.21-2.79-4.92,2.73-4.83,4.82-4.91c-.61,2.71.7,4.91,2.82,4.91Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.49 415.85 166.99 417.91 173 418.9 174.75 412.69 169.32 411.04 156.06 407.01 154.49 415.85",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.52,411.68l-2.7,7a.74.74,0,0,0,.44,1l3.49,1.24s4.58,2,6.06,1.36c4.32-1.86,10.7-17.11,9.3-18.55-.52-.52-1.64,0-2.23.4-1.87,1.38-6,5.4-7.63,6.53-1.84,1.32-4.66.91-5.89.64A.75.75,0,0,0,173.52,411.68Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.49 415.85 166.99 417.91 169.32 411.04 156.06 407.01 154.49 415.85",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.17,409.75s-51-28.66-68.57-27.84-20.12,16.32-12.87,26S106.39,420,106.39,420s-9.12-12.89-7.8-16.52,6.48,1.44,6.48,1.44,32.07,10.35,60.12,12.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.99 408.96 165.1 407.02 161.4 418.41 165.85 418.41 167.99 408.96",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.99 408.96 165.1 407.02 161.4 418.41 165.85 418.41 167.99 408.96",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.68,312.27c-1.84,2.63,20.78,6.86,20.78,6.86s13.24-8.59-2.22-9.93C108.09,308.92,95.59,308.14,92.68,312.27Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.2,324s12.19-10.06,5.88-16.08-36-8.71-33.49,5c0,0,3.82-1.13,7.68,2.55C102.4,323.25,114.2,324,114.2,324Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.18,321.11s6.9-5.36,4.47-10.19-16.79-10.12-27.08-3.46a32,32,0,0,1,6.82,4.7C101.47,315.65,113.18,321.11,113.18,321.11Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.39,312.16s3.31,4.73,15.79,8.95c0,0,5.56-7.07-2.89-10.3,0,0-1.76-.55-2.14-3.35a13.58,13.58,0,0,1,.75-5.83c.09-.3.2-.62.31-.94l-10.28-6.43S102.55,307.29,97.39,312.16Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.24,298s.55,7.35,6.91,9.47a13.58,13.58,0,0,1,.75-5.83C105.15,299.65,101.24,298,101.24,298Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.11,300.77a6,6,0,0,1-5-2,.25.25,0,0,1,0-.35.24.24,0,0,1,.35,0c2.81,3.66,10.77.55,10.85.52a.25.25,0,0,1,.33.14.24.24,0,0,1-.14.32A19.65,19.65,0,0,1,94.11,300.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.71,277.42a.27.27,0,0,1-.16-.06.25.25,0,0,1,0-.35,6.17,6.17,0,0,0-.49-8.18c-3.8-4.05-9.47-.61-9.53-.58a.25.25,0,1,1-.26-.42c.06,0,6.08-3.69,10.16.66a6.75,6.75,0,0,1,.51,8.83A.28.28,0,0,1,114.71,277.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.3,277.72a.26.26,0,0,1-.21-.11.25.25,0,0,1,.07-.34s2.61-1.78,2.9-4.15a4.1,4.1,0,0,0-1.22-3.3.25.25,0,0,1,0-.36.26.26,0,0,1,.36,0,4.6,4.6,0,0,1,1.35,3.7c-.32,2.6-3,4.42-3.12,4.5A.23.23,0,0,1,114.3,277.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.42,276.47a10.48,10.48,0,0,0-7.91-11.37c-9.17-2.77-18.63,6.34-18.63,6.34s-7.12,29.36,12.59,27.78S114.42,276.47,114.42,276.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,273.39c8.48-.79,11.64,3.49,13.08,12.18,1.8,10.86.11,18.85-10.72,17.51C91.6,301.26,89.85,274.71,104,273.39Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.5,285.61a18.21,18.21,0,0,0,2.8,3.29,2.35,2.35,0,0,1-2.15,1.17Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.24,285.4c.08.7-.23,1.31-.69,1.36s-.91-.46-1-1.16.23-1.3.69-1.36S106.16,284.71,106.24,285.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.07,284.3l1.44-.77S105.9,284.89,105.07,284.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.87,284.25c.08.69-.22,1.3-.69,1.35s-.9-.46-1-1.16.23-1.3.7-1.36S114.79,283.55,114.87,284.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.7,283.14l1.44-.77S114.54,283.73,113.7,283.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.05,281.54a.36.36,0,0,1-.2-.06.35.35,0,0,1-.1-.5,4.77,4.77,0,0,1,3.87-1.79.36.36,0,0,1,.35.37.39.39,0,0,1-.37.35,4.12,4.12,0,0,0-3.25,1.47A.35.35,0,0,1,102.05,281.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.19,279.36a.47.47,0,0,1-.17,0,3.64,3.64,0,0,0-3.12-.38.36.36,0,0,1-.31-.65,4.31,4.31,0,0,1,3.77.39.35.35,0,0,1,.15.49A.36.36,0,0,1,115.19,279.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,288.56s3.32-7.34,2.21-12.67c0,0,16.18-8.44,18.61,8.55,0,0,.22-15.31-14.4-14.28s-12.56,22.36-4.43,28C98,298.18,94,293.16,96,288.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.57,290.23a3.75,3.75,0,0,0-4.33-3c-2.6.53-3.35,6.05,3.31,6.73C97.51,294,98,293.07,97.57,290.23Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.46,293.35a21.51,21.51,0,0,0-.92,2.9l-.54,0c-2.43-.21-3.48-1.11-3.92-2a3.08,3.08,0,0,1-.26-1.46,3.15,3.15,0,0,1,.14-.84,11.36,11.36,0,0,0,4.68,1.39C113.14,293.33,113.46,293.35,113.46,293.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.64,293.26l-.3.85c-2.28-.2-3.87-.65-4.52-1.4a3.15,3.15,0,0,1,.14-.84A11.36,11.36,0,0,0,112.64,293.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,296.21c-2.43-.21-3.48-1.11-3.92-2a7.73,7.73,0,0,1,2.65.77A2.92,2.92,0,0,1,112,296.21Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.67,270.11s4.08-6.49-2.85-9.07-13.64,6.35-9.49,12.52a9.53,9.53,0,0,0,10.78,3.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.12,269.48a.22.22,0,0,1-.16-.05.24.24,0,0,1,0-.35c.18-.21,4.2-5.19.49-8.3a.25.25,0,0,1,0-.35.24.24,0,0,1,.35,0c4.1,3.42-.38,8.94-.42,9A.25.25,0,0,1,92.12,269.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.69,279.12a7.45,7.45,0,0,1-7-8.95c.43-2.19,1.78-3.62,3.62-3.82a.24.24,0,0,1,.28.22.25.25,0,0,1-.22.27c-1.62.18-2.81,1.46-3.19,3.43a7,7,0,0,0,3.28,7.39c4.55,2.44,6.22-.49,6.28-.61a.25.25,0,0,1,.34-.1.24.24,0,0,1,.1.33A4,4,0,0,1,84.69,279.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.56,321.79a.69.69,0,1,1-.68-.68A.69.69,0,0,1,110.56,321.79Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.44,319.81a.68.68,0,0,1-.68.69.69.69,0,1,1,0-1.37A.68.68,0,0,1,117.44,319.81Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.85,326.71a.69.69,0,1,1-.69-.68A.69.69,0,0,1,123.85,326.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,330.23a.68.68,0,1,1-.68-.68A.68.68,0,0,1,109,330.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,327h0s-2.67-.36-3.13-3.77a3.05,3.05,0,0,0-3.06-2.95c-.14,0-.26-.1-.26-.24a.24.24,0,0,1,.24-.26,3.59,3.59,0,0,1,3.58,3.38c.4,3,2.67,3.34,2.69,3.35a.25.25,0,0,1,.22.27A.26.26,0,0,1,123,327Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.32,330.23a.25.25,0,0,1-.25-.24,6.63,6.63,0,0,1,1.79-4.74,2.27,2.27,0,0,0,.77-1.63,2.71,2.71,0,0,0-.76-1.67.25.25,0,1,1,.34-.36,3.09,3.09,0,0,1,.92,2,2.78,2.78,0,0,1-.91,2,6.19,6.19,0,0,0-1.65,4.35.26.26,0,0,1-.23.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.52,314.5c7.17-5.76,4.45,26.65,7.83,34s23.54,24.83,23.54,24.83l-4.33,4.86s-24.6-13.57-28-22.67C78.13,344,78.22,318.74,83.52,314.5Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.52,314.5c7.17-5.76,4.45,26.65,7.83,34s23.54,24.83,23.54,24.83l-4.33,4.86s-24.6-13.57-28-22.67C78.13,344,78.22,318.74,83.52,314.5Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.89 373.37 117.65 375.7 113.86 380.32 110.56 378.23 114.89 373.37",
    style: {
      fill: "#00AB65"
    }
  })), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "rgb(0, 171, 101)",
      fontFamily: "'Segoe UI'",
      fontSize: 17,
      fontWeight: 700,
      textAnchor: "middle",
      whiteSpace: "pre"
    },
    transform: "matrix(1, 0, 0, 1, 56.029218, 1.827013)"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 187.881,
    y: 252.893
  }, "No Media Files ")), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 187.881,
    dy: "1em"
  }, "\u200B")), _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", null, "Available"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMediaLibrary);
export default __webpack_public_path__ + "static/media/no-media-library.28b3c43634bc6903224df20e168e55bf.svg";
export { ForwardRef as ReactComponent };